// ----------------------------------------------------------------------

const contact = [
  {
    id: '1',
    title: 'EPC Co-ordinator',
    description: 'desc1'
  },
  {
    id: '2',
    title: 'EPC Travel Co-ordinator',
    description: 'desc2'
  },
  {
    id: '3',
    title: 'EPC Media Co-ordinators',
    description: 'desc3'
  },
  {
    id: '4',
    title: 'Test title 4',
    description: 'desc4'
  }
];

export default contact;
